import firebase from "@firebase/app";
import "firebase/auth";
import "firebase/firestore";

import { userService } from "../services/userService";

export default {
  state: {
    user: null,
    isLogged: false
    // topUsers: [],
    // loadTopUsers: true
    // savedWords: []
  },
  getters: {
    user(state) {
      return state.user;
    },
    isLogged(state) {
      return state.isLogged;
    }
    // topUsers(state) {
    //     return state.topUsers
    // },
    // loadTopUsers(state) {
    //     return state.loadTopUsers
    // }
    // savedWords(state) {
    //     return state.savedWords
    // }
  },
  mutations: {
    // setUser(state, user) {
    //     if (user) {
    //         state.user = !!payload.courseLocation ? payload : {
    //             ...payload, courseLocation: {
    //                 chapter: 1,
    //                 lesson: 1
    //             }
    //         }
    //     } else {
    //         state.user = null
    //     }
    // },
    setUser(state, user) {
      state.user = user;
    },
    setIsLogged(state, isLogged) {
      state.isLogged = isLogged;
    },
    updateUser(state, user) {
      state.user = user;
    },
    updateUserWords(state, user) {
      state.user = user;
    },
    // setTopUsers(state, topUsers) {
    //     state.topUsers = topUsers
    //     state.loadTopUsers = false
    // },
    setLoader(state) {
      state.loadTopUsers = true;
    }
    // setSavedWords(state, savedWords) {
    //     state.savedWords = savedWords
    // }
  },
  actions: {
    // async setTopUsers({ commit }) {
    //     commit('setLoader')
    //     const topUsers = await userService.getTopUsers()
    //     commit('setTopUsers', topUsers)
    // },
    loginWith({ commit }, payload) {
      const user = userService.loginWith(payload);
      dispatch("subscribeToUserChanges", user.uid);
      commit("setUser", user);
    },
    // async setSavedWords({ commit }, { user }) {
    //     const savedWords = await wordService.getSavedWords(user)
    //     commit('setSavedWords', savedWords)
    // },
    autoSignIn({ dispatch }, { uid }) {
      dispatch("subscribeToUserChanges", uid);
    },
    logout({ commit }) {
      firebase.auth().signOut();
      commit("setUser", null);
    },
    subscribeToUserChanges({ commit, dispatch }, uid) {
      const db = firebase.firestore();
      const doc = db.collection("users").doc(uid);
      doc.onSnapshot(async doc => {
        const source = doc.metadata.hasPendingWrites ? "Local" : "Server";
        let user = doc.data();
        if (!user.savedWords) {
          user.savedWords = [];
          user.knownLaws = [];
          user.knownWords = [];
          user.chapters = [];
          user = await userService.updateUser(user);
        }
        await commit("setUser", { id: uid, ...user });
        // await dispatch('getUserActions', uid)
      });
    },
    async updateUser({ commit }, { user }) {
      const updatedUser = await userService.updateUser(user);
      commit("updateUser", updatedUser);
    },
    async updateProgressUser({ commit }, { changes }) {
      let { user } = this.getters;
      if (user) {
        user = await userService.updateProgressUser(user, changes);

        commit("setUser", user);
      }
    },
    async updateSavedWordsUser({ commit }, word) {
      let { user } = this.getters;
      if (user) {
        user = await userService.updateSavedWordsUser(user, word.id);
        commit("setUser", user);
      }
    },
    userPaymentProcessing({ commit }) {
      commit("setLoading", true);
    },
    userPaymentFinished({ commit }) {
      commit("setLoading", false);
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/user.store.js